import * as notifications from '../actions/notifications';
import { Action, createReducer, on } from '@ngrx/store';
import { Notification } from '../interfaces';

export interface State {
  notificationCounter: number;
  notifications: Notification[];
}

const initialState: State = {
  notificationCounter: 0,
  notifications: []
};

export const notificationsReducer = createReducer(
  initialState,
  on(notifications.AddSuccessNotification, (state, action) => {
    return Object.assign({}, state, {
      notificationCounter: state.notificationCounter + 1,
      notifications: state.notifications.concat({
        id: state.notificationCounter,
        message: action.payload,
        isError: false
      })
    });
  }),
  on(notifications.AddFailureNotification, (state, action) => {
    return Object.assign({}, state, {
      notificationCounter: state.notificationCounter + 1,
      notifications: state.notifications.concat({
        id: state.notificationCounter,
        message: action.payload,
        isError: true
      })
    });
  }),
  on(notifications.RemoveNotification, (state, action) => {
    return Object.assign({}, state, {
      notifications: state.notifications.filter(
        (notification) => notification.id !== action.payload
      )
    });
  })
);

export function reducer(state: State | undefined, action: Action): State {
  return notificationsReducer(state, action);
}

export const getNotifications = (state: State) => state.notifications;
